import React from 'react'

const Error = ({ color, ...props }) => {
  return (
    <svg
      {...props}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.9997 23.6673C5.55635 23.6673 0.333008 18.444 0.333008 12.0007C0.333008 5.55733 5.55635 0.333984 11.9997 0.333984C18.443 0.333984 23.6663 5.55733 23.6663 12.0007C23.6593 18.441 18.4401 23.6602 11.9997 23.6673ZM10.833 15.5007V17.834H13.1663V15.5007H10.833ZM10.833 6.16732V13.1673H13.1663V6.16732H10.833Z"
        fill="#F05A26"
      />
    </svg>
  )
}

export default Error
